import type { PromptModelConfigCreate } from '~/api/sylvanus/typedefs.autogen';

import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeModelVersion,
  mapDdeModelVersion,
  type ServerDdeModelVersion,
  type ServerDdeModelVersionCreateRequest,
} from './ddeModelTypes';

type CreateDdeModelVersionRequest = {
  configuration: PromptModelConfigCreate;
  modelId: string;
  tableId: string;
};

const mapRequest = ({
  configuration,
}: Pick<
  CreateDdeModelVersionRequest,
  'configuration'
>): ServerDdeModelVersionCreateRequest => ({
  configuration,
});

export const createDdeModelVersion = async ({
  configuration,
  modelId,
  tableId,
}: CreateDdeModelVersionRequest): Promise<DdeModelVersion> => {
  const response = await sylvanus.post<ServerDdeModelVersion>(
    `/dde/table/${tableId}/model/${modelId}/version`,
    mapRequest({ configuration }),
  );

  return mapDdeModelVersion(response);
};
